import { useEffect } from "react";
import { LEGACY_MESMA_APP_ORIGIN } from "../../../Data/NavbarData";

type LegacyBlazorRedirectProps = {
  /** Blazor route path, e.g. `/Notifications`. */
  blazorPath: string;
};

/**
 * Innovate has no page for several legacy-only modules. If MFA or a relative
 * return URL lands the user here, send them to the classic Blazor app.
 */
const LegacyBlazorRedirect = ({ blazorPath }: LegacyBlazorRedirectProps) => {
  useEffect(() => {
    const target = new URL(blazorPath, LEGACY_MESMA_APP_ORIGIN);
    target.searchParams.set("allowLegacy", "1");
    window.location.replace(target.toString());
  }, [blazorPath]);

  return null;
};

export default LegacyBlazorRedirect;
